import classNames from 'classnames/bind';

import { getListMaster, ResponseSuccessPagination, submitFavMasterTrader } from '@/controllers/gridManager/followerTransManager/followerTransManager';
import ButtonElement, { ColorButton } from '@/views/elements/button/ButtonElement';
import CloseIcon from '@mui/icons-material/Close';
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { Badge, Box } from '@mui/material';
import { useEffect, useMemo, useRef, useState } from 'react';
import CopyMasterTrade from '../Follower/CopyMasterTrade/CopyMasterTrade';
import RegisterFollower from '../Follower/RegisterFollower/RegisterFollower';
import GridCardInfo from '../ShareMasterFollower/GridCardInfo';
import styles from './HomeCPComponent.module.scss';
import ModalRegisterMasterFollower from './ModalRegisterMasterFollower';
//import Button from '@/views/elements/Button/Button';

import PaginationElement from '@/views/elements/pagination/PaginationElement';
import TabOnlyElement from '@/views/elements/tab/TabOnlyElement';
import StarOutlineRoundedIcon from '@mui/icons-material/StarOutlineRounded';
import Grid from '@mui/material/Grid2';
import { Stack } from '@mui/system';
import { produce } from 'immer';
import HoldingPortfolio from '../Master/HoldingPortfolio/HoldingPortfolio';
import RegisterMaster from '../Follower/RegisterMasterModal/RegisterMasterModal';
import CopyStatisticsChart from '../ShareMasterFollower/Charts/CopyStatisticsChart';
import InvestmentEfficiencyChart from '../ShareMasterFollower/Charts/InvestmentEfficiencyChart';
import MasterPointChart from '../ShareMasterFollower/Charts/MasterPointChart';
import ProfitLossHistoryChart from '../ShareMasterFollower/Charts/ProfitLossHistoryChart';
import ModalAdvanceFilter from '../ShareMasterFollower/ModalAdvanceFilter';
import RenderProfitLoss from '../ShareMasterFollower/RenderProfitLoss';
import UserInfoView from '../ShareMasterFollower/UserInfoView/UserInfoView';
import { formatDate, getScrollTop, scrollToTop } from '@/utilities';
import StyledTab from '../../StyledTab/StyledTab';
import { useSearchParams } from 'react-router-dom';
import AllocationCategoryChart from '../ShareMasterFollower/Charts/AllocationCategoryChart';
import ToastUtil from '../../Toast/Toast';
import OrderHistoryPanel from './OrderHistoryPanel/OrderHistoryPanel';
import PNLHistoryPanel from './PNLHistoryPanel/PNLHistoryPanel';
import CopyHistoryPanel from './CopyHistoryPanel/CopyHistoryPanel';
import { isEmpty } from 'lodash';
import BannerRegister from './BannerRegister/BannerRegister';
import OutlinedInputElement from '@/views/elements/Inputs/OutlinedInputElement';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { useCosInfo, useUserInfo } from '@/controllers/gridManager/accountsManager/accountManager';
import { useGetCosConfig } from '@/controllers/gridManager/appManager/appManager';
import { useTranslation } from 'react-i18next';
import StopCopy from '../Follower/StopCopy/StopCopy';
import { STATUS_ACCOUNT } from '@/stores/dataStore/memoryStore/const/constIndex';
import useIsMobile from '@/componentShare/hooks/useIsMobile';

const cx = classNames.bind(styles);

type Props = {}

export type TYPE_REGISTER = "FOLLOWER" | "MASTER"

export type PropertyFilter = {
    time: string,
    effective: number | string,
    asset: number | string,
    minInvest: number | string,
}

const initProperty: PropertyFilter = {
    asset: '',
    effective: '',
    minInvest: '',
    time: ''
}

export default function HomeCPComponent({ }: Props) {
    const { t } = useTranslation()
    const { cosConfig } = useGetCosConfig()
    const { minnetasset } = cosConfig
    const { cosInfo } = useCosInfo()
    const { userInfo } = useUserInfo()
    const { custodycd } = userInfo
    const { cosrole } = cosInfo
    const FollowingMTStatus = cosInfo.status
    const isRegisterMF = ((cosrole && cosrole === "F") || (cosrole && cosrole === "M")) ? true : false
    const currentMainScrollTop = useRef<number>(0)

    const [reloadValue, setReloadValue] = useState<number>(0)
    const [openModalStopCopy, setOpenModalStopCopy] = useState<boolean>(false)

    const TAB = {
        INVESTMENT_CAPITAL: {
            id: 'best.profit',
            label: t("copytrade.topMaster.INVESTMENT_CAPITAL"),
            type: 'INVESTMENT_CAPITAL'
        },
        IS_FOLLOWING: {
            id: 'isFollowing',
            label: t("copytrade.topMaster.IS_FOLLOWING"),
            type: 'IS_FOLLOWING'
        },
        MOST_FOLLOW: {
            id: 'best.copy',
            label: t("copytrade.topMaster.MOST_FOLLOW"),
            type: 'MOST_FOLLOW'
        },
        TOP_NAV: {
            id: 'best.asset',
            label: t("copytrade.topMaster.TOP_NAV"),
            type: 'TOP_NAV'
        },
        TOP_POINT: {
            id: 'best.score',
            label: t("copytrade.topMaster.TOP_POINT"),
            type: 'TOP_POINT'
        },
        COPIER_PNL: {
            id: 'best.profit.copier',
            label: t("copytrade.topMaster.COPIER_PNL"),
            type: 'COPIER_PNL'
        },
    }


    let TABS = !isRegisterMF ? [TAB.INVESTMENT_CAPITAL, TAB.MOST_FOLLOW, TAB.TOP_NAV, TAB.TOP_POINT, TAB.COPIER_PNL] :
        [TAB.INVESTMENT_CAPITAL, TAB.IS_FOLLOWING, TAB.MOST_FOLLOW, TAB.TOP_NAV, TAB.TOP_POINT]

    let tabByRole = [...TABS]
    console.log('ha_check_cosrole', { cosrole, cosInfo });

    const [searchParams, setSearchParams] = useSearchParams()
    const [open, setOpen] = useState<boolean>(false)
    const [openViewMaster, setOpenViewMaster] = useState<boolean>(false)
    const [dataMasterTradeView, setDataMasterTradeView] = useState<any>({}) // info for view popup full detail Master
    const [currentTab, setCurrentTab] = useState<any>(tabByRole[0])
    const [searchQuery, setSearchQuery] = useState<string>('')
    const [debounceSearchQuery, setDebounceSearchQuery] = useState<string>('')
    const [openModalAdvanceFilter, setOpenModalAdvanceFilter] = useState<boolean>(false)
    const [propertyFilter, setPropertyFilter] = useState<PropertyFilter>({ ...initProperty })
    const [preViewPropertyFilter, setPreViewPropertyFilter] = useState<PropertyFilter>({ ...initProperty })
    const [openModalRegister, setOpenModalRegister] = useState<boolean>(false)
    const [openModalCopyMasterTrade, setOpenModalCopyMasterTrade] = useState<boolean>(false)
    const [dataMasterTradeId, setDataMasterTradeId] = useState<any>({}) // info for view popup action on listMaster
    const [typeRegister, setTypeRegister] = useState<TYPE_REGISTER>("FOLLOWER")
    const [listMaster, setListMaster] = useState<any[]>([])
    const [pageSize, setPageSize] = useState<number>(20)
    const [total, setTotal] = useState<number>(0)
    const [pageIndex, setPageIndex] = useState<number>(1)
    const [disabledActionPagination, setDisabledActionPagination] = useState<boolean>(true)

    const TABS2 = [
        {
            label: t("copytrade.topMaster.overview"),
            Panel: <>
                <Grid container spacing={3} columns={{ xs: 6, sm: 6, md: 6, lg: 12 }}>
                    <Grid size={6} height={"390px"}>
                        <AllocationCategoryChart
                            accountId={dataMasterTradeView?.afacctno}
                            masterAccount=''
                        />
                    </Grid>

                    <Grid size={6} maxHeight='400px'>
                        <HoldingPortfolio accountId={dataMasterTradeView?.afacctno} />
                    </Grid>

                    <Grid size={6} height={"390px"}>
                        <InvestmentEfficiencyChart
                            fullWidth={true}
                            accountId={dataMasterTradeView?.afacctno}
                            cosrole='M'
                        />
                    </Grid>


                    <Grid size={6} height={"390px"}>
                        <ProfitLossHistoryChart
                            fullWidth={true}
                            accountId={dataMasterTradeView.afacctno}
                            masterAccount=''
                            cosrole='M'
                        />
                    </Grid>

                    <Grid size={6} height={"390px"}>
                        <CopyStatisticsChart
                            fullWidth={true}
                            accountId={dataMasterTradeView?.afacctno}
                        />
                    </Grid>

                    <Grid size={6} height={"390px"}>
                        <MasterPointChart accountId={dataMasterTradeView.afacctno} />
                    </Grid>
                </Grid></>
        },
        {
            label: t("copytrade.topMaster.orderHistory"),
            Panel: <OrderHistoryPanel accountId={dataMasterTradeView?.afacctno} />
        },
        {
            label: t("copytrade.topMaster.pnlHistory"),
            Panel: <PNLHistoryPanel />
        },
        {
            label: t("copytrade.topMaster.copyHistory"),
            Panel: <CopyHistoryPanel mtAccountId={dataMasterTradeView?.afacctno} />
        }
    ]

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,
    ) => {
        setDisabledActionPagination(true)
        if (disabledActionPagination === false) {
            const nPage = newPage + 1
            setPageIndex(nPage);
        }
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setDisabledActionPagination(true)
        if (disabledActionPagination === false) {
            setPageSize(parseInt(event.target.value, 10));
            setPageIndex(1);
        }
    };

    const wrapperSetOpenViewMaster = (status: boolean) => {
        if (status === true) {
            currentMainScrollTop.current = getScrollTop()
        }
        setOpenViewMaster(status)
    }

    useEffect(() => {
        if (openViewMaster === true) {
            scrollToTop()
        } else {
            scrollToTop('', currentMainScrollTop.current)
        }
    }, [openViewMaster])

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setDebounceSearchQuery(searchQuery);
        }, 500);
        return () => clearTimeout(timeoutId);
    }, [searchQuery]);

    useEffect(() => {
        if (dataMasterTradeView && dataMasterTradeView.custodycd) {
            const rs = listMaster.find((item: any) => {
                return dataMasterTradeView.custodycd === item.custodycd
            })
            rs && setDataMasterTradeView(rs)
        }
    }, [listMaster]);

    useEffect(() => {
        const { type } = currentTab

        async function callApiListMaster(type: string, searchQuery: string, pageSize: number, pageIndex: number, custodycd: string, isDetailMaster?: boolean, mtAcctno?: string,) {
            const { isSuccess, data } = await getListMaster({ typeOrder: type, searchQuery, pageSize, pageIndex, custodycd, mtAcctno })
            const rs = data as ResponseSuccessPagination

            if (isDetailMaster === true) {
                setDataMasterTradeView(rs.data[0] ?? {})
                wrapperSetOpenViewMaster(true)
                return;
            }

            if (isSuccess) {
                setListMaster(rs.data)
                setPageSize(rs.pageSize)
                setTotal(rs.total)
                setPageIndex(rs.pageIndex)
            }
            setDisabledActionPagination(false)
        }

        if (searchParams && searchParams.get('mt-code')) {
            const mtAcctno = searchParams.get('mt-code') ?? ''
            callApiListMaster('', '', pageSize, 1, '', true, mtAcctno)
        } else {
            callApiListMaster(type, searchQuery, pageSize, pageIndex, custodycd)
        }
    }, [currentTab, debounceSearchQuery, pageSize, pageIndex, searchParams, reloadValue])

    const handleRegister = (mode?: TYPE_REGISTER) => {
        if (mode === 'FOLLOWER') {
            setTypeRegister('FOLLOWER')
            setOpenModalRegister(true)
        } else if (mode === 'MASTER') {
            setTypeRegister('MASTER')
            setOpenModalRegister(true)
        } else {
            setOpen(true)
        }
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleCloseModalRegister = () => {
        setOpenModalRegister(false)
    }

    const handleCloseModalCopyMasterTrade = () => {
        setOpenModalCopyMasterTrade(false)
        setDataMasterTradeId({})
    }

    const handleCloseViewData = () => {
        if (searchParams && searchParams.get('mt-code')) {
            setSearchParams({})
        }
        wrapperSetOpenViewMaster(false)
    }


    const handleCopy = (info: any) => {
        if (cosrole === 'N') {
            setOpen(true)
        }
        else {
            if (!isEmpty(info)) {
                setDataMasterTradeId(info)
            } else {
                setDataMasterTradeId(dataMasterTradeView)
            }
            setOpenModalCopyMasterTrade(true)
        }
    }

    const handleFollow = async (info: any) => {
        const masterAccountId = info?.afacctno ?? ''
        const masterCustodycd = info?.custodycd ?? ''
        const action = info?.is_following === 1 ? 'U' : 'F' // unFollow, follow, 
        await submitFavMasterTrader({ accountId: cosInfo.refaccount, action, masterAccountId, masterCustodycd }).then((rs) => {
            if (rs.isSuccess === true) {
                triggerReload()
                ToastUtil.success(t("copytrade.common.success"))
            }
        })
    }

    const handleFollowOnDetail = async () => {
        const masterAccountId = dataMasterTradeView?.afacctno ?? ''
        const masterCustodycd = dataMasterTradeView?.custodycd ?? ''
        const action = dataMasterTradeView?.is_following === 1 ? 'U' : 'F'
        await submitFavMasterTrader({ accountId: cosInfo.refaccount, action, masterAccountId, masterCustodycd }).then((rs) => {
            if (rs.isSuccess === true) {
                triggerReload()
                ToastUtil.success(t("copytrade.common.success"))
            }
        })
    }

    const triggerReload = async () => {
        setReloadValue(prevCount => prevCount + 1)
    }

    const handleCallBackChangeTab = (id: string) => {
        setCurrentTab(id)
        setPageIndex(1);
    }

    const handleChangeInput = (e: any) => {
        setSearchQuery(e.target.value)
    }

    const handleCloseModalAdvanceFilter = () => {
        setOpenModalAdvanceFilter(false)
    }

    const handleSaveAdvanceFilter = () => {
        setPropertyFilter(preViewPropertyFilter)
    }

    const handleResetAdvanceFilter = () => {
        setPreViewPropertyFilter(propertyFilter)
    }

    const handChangeAdvProperty = (id: string, value: string | number) => {
        // console.log('ha_check_handChangeAdvProperty', { id, value });
        setPreViewPropertyFilter(produce((draft: any) => {
            draft[id] = value
        }))
    }

    const handleResetAllAdvanceFilter = () => {
        setPropertyFilter({ ...initProperty })
        setPreViewPropertyFilter({ ...initProperty })

    }

    const safePage = (index: number) => {
        return (index - 1) < 0 ? 0 : (index - 1)
    }

    const actions = () => {
        if (cosrole === "F") {
            return [
                {
                    label: dataMasterTradeView.is_following ? t("copytrade.common.unFollow") : t("copytrade.common.follow"),
                    color: 'Secondary' as ColorButton,
                    prependIcon: <StarOutlineRoundedIcon sx={{ fontSize: "20px", paddingBottom: '1px' }} />,
                    disabled: FollowingMTStatus === STATUS_ACCOUNT.WC,
                    onClick: handleFollowOnDetail
                },
                {
                    label: dataMasterTradeView.is_copying ? t("copytrade.common.stopCopy") : t("copytrade.common.copy"),
                    // prependIcon: <CopyAllRoundedIcon />,
                    disabled: dataMasterTradeView.flstatus === STATUS_ACCOUNT.WC,
                    onClick: dataMasterTradeView.is_copying ? () => handleStop(dataMasterTradeView) : () => handleCopy(dataMasterTradeView)
                },
            ]
        } else if (cosrole === "M") {
            if (custodycd !== dataMasterTradeView.custodycd) {
                return [
                    {
                        label: dataMasterTradeView.is_following ? t("copytrade.common.unFollow") : t("copytrade.common.follow"),
                        color: 'Secondary' as ColorButton,
                        prependIcon: <StarOutlineRoundedIcon sx={{ fontSize: "20px", paddingBottom: '1px' }} />,
                        onClick: handleFollowOnDetail
                    }
                ]
            } else return []
        } else {
            return [
                {
                    label: dataMasterTradeView.is_following ? t("copytrade.common.unFollow") : t("copytrade.common.follow"),
                    color: 'Secondary' as ColorButton,
                    prependIcon: <StarOutlineRoundedIcon sx={{ fontSize: "20px", paddingBottom: '1px' }} />,
                    disabled: true
                },
                {
                    label: dataMasterTradeView.is_copying ? t("copytrade.common.stopCopy") : t("copytrade.common.copy"),
                    // prependIcon: <CopyAllRoundedIcon />,
                    onClick: () => handleCopy({}),
                    disabled: true
                },
            ]
        }
    }

    const achivements = [
        {
            title: t("copytrade.topMaster.numberFollower"),
            value: dataMasterTradeView?.follower_number
        },
        {
            title: t("copytrade.topMaster.numberCopied"),
            value: dataMasterTradeView?.copier_number
        },
        {
            title: t("copytrade.topMaster.minInvest"),
            value: minnetasset || 0
        },
        {
            title: t("copytrade.topMaster.minCopyNumber"),
            value: dataMasterTradeView?.mininvestamt
        },
        {
            title: t("copytrade.topMaster.bonusFee"),
            value: dataMasterTradeView?.feerate
        },
        {
            title: t("copytrade.topMaster.navMaster"),
            value: dataMasterTradeView?.nav
        },
        {
            title: t("copytrade.topMaster.navCopy"),
            value: dataMasterTradeView?.aum
        },
        {
            title: t("copytrade.topMaster.effective1m"),
            render: <RenderProfitLoss fontSizeElement='14px' fontWeightElement={500} data={dataMasterTradeView?.r_1_mon || 0} />
        },
        {
            title: t("copytrade.topMaster.effective3m"),
            render: <RenderProfitLoss fontSizeElement='14px' fontWeightElement={500} data={dataMasterTradeView?.r_3_mon || 0} />
        },
        {
            title: t("copytrade.topMaster.onDay"),
            render: <RenderProfitLoss fontSizeElement='14px' fontWeightElement={500} data={dataMasterTradeView?.dr || 0} />
        },
    ]


    const countBadge = useMemo(() => {
        let count = 0
        const arrayProperty: (keyof PropertyFilter)[] = Object.keys(propertyFilter) as (keyof PropertyFilter)[]
        for (let index = 0; index < arrayProperty.length; index++) {
            arrayProperty[index]
            const element = propertyFilter[arrayProperty[index]]
            if (element !== '') {
                count++
            }
        }
        return count
    }, [propertyFilter])

    const handleCloseModalStopCopy = () => {
        setOpenModalStopCopy(false)
    }

    const handleStop = (info: any) => {
        if (cosrole === 'N') {
            setOpen(true)
        }
        else {
            if (!isEmpty(info)) {
                setDataMasterTradeId(info)
            } else {
                setDataMasterTradeId(dataMasterTradeView)
            }
            setOpenModalStopCopy(true)
        }
    }

    // console.log('ha_check_dataMasterTradeView', dataMasterTradeView);

    const matches = useIsMobile();

    return (
        <>
            <div className={cx("home-copy-trade")}>
                {openViewMaster && <Box sx={{ position: "absolute", right: "20px", top: "16px" }} ><CloseIcon onClick={handleCloseViewData} /></Box>}


                <div className="head-viewer-detail">
                    {openViewMaster === false ? <div className="combo-tile">
                        <div className={cx("main-title")}>
                            <TypographyElement ColorElement="secondary" FontSizeElement="12px" FontWeightElement={500} lineHeight={"18px"}> {
                                openViewMaster ? t('copytrade.topMaster.title') : t('copytrade.common.copytrading')
                            }</TypographyElement>

                        </div>

                        <div className={cx("title")}>
                            <TypographyElement FontSizeElement="18px" FontWeightElement={700} lineHeight={"27px"}> {
                                openViewMaster ? t('copytrade.topMaster.detailMaster') : t('copytrade.topMaster.title')
                            }</TypographyElement>
                        </div>
                    </div> :
                        <UserInfoView
                            achivements={achivements}
                            section={t('copytrade.topMaster.title')}
                            title={t('copytrade.topMaster.detailMaster')}
                            name={dataMasterTradeView?.mt_fullname}
                            registerDate={formatDate(dataMasterTradeView?.reg_date)}
                            rank={dataMasterTradeView?.mt_rank ?? "M"}
                            investthesis={dataMasterTradeView?.investthesis}
                            shortinvestthesis={dataMasterTradeView?.shortinvestthesis}
                            actions={actions()}
                        />
                    }
                </div>


                <div className={openViewMaster ? cx('hidden-visibility') : ''}>

                    <div className={matches === true ? cx("tabbar-and-search", "mobile") : cx("tabbar-and-search")}>
                        <TabOnlyElement tabs={tabByRole} callBackChangeTab={handleCallBackChangeTab}></TabOnlyElement>

                        <Stack direction={'row'} spacing={1}>
                            <OutlinedInputElement
                                size='small'
                                placeholder={t("copytrade.topMaster.searchMaster")}
                                value={searchQuery}
                                onChange={(e) => handleChangeInput(e)}
                                id="valueStopProfit"
                                startAdornment={<SearchIcon />}
                            />

                            <ButtonElement customType="Transparent" variant="text" onClick={() => setOpenModalAdvanceFilter(true)} >
                                <Stack direction={'row'} spacing={1}>
                                    {countBadge !== 0 ? <Badge badgeContent={countBadge} color="primary" >
                                        <FilterAltOutlinedIcon />
                                    </Badge> : <FilterAltOutlinedIcon />}
                                    <TypographyElement ColorElement='primary' FontSizeElement='14px' FontWeightElement={400}>{t("copytrade.topMaster.advFilter")}</TypographyElement>
                                </Stack>
                            </ButtonElement>

                            {countBadge !== 0 && <ButtonElement variant="text" onClick={() => handleResetAllAdvanceFilter()} >
                                <Stack direction={'row'} spacing={1}>
                                    <FilterAltOffOutlinedIcon />
                                    <TypographyElement ColorElement='primary' FontSizeElement='14px' FontWeightElement={400} >{t("copytrade.common.cancel")}</TypographyElement>
                                </Stack>
                            </ButtonElement>}
                        </Stack>

                    </div>

                    {(isRegisterMF === false) && <BannerRegister
                        handleRegister={handleRegister}
                    />}

                    <div className={cx("grid-list-master")}>

                        <Box>
                            <GridCardInfo data={listMaster}
                                onCopy={handleCopy}
                                onFollow={handleFollow}
                                onRegister={handleRegister}
                                onStop={handleStop}
                                dataSelected={dataMasterTradeId}
                                onSelected={wrapperSetOpenViewMaster}
                                setDataSelected={setDataMasterTradeView}
                                status={isRegisterMF}
                                isPrivate={false}
                            />
                        </Box>
                    </div>
                    <PaginationElement
                        component="div"
                        count={total}
                        page={safePage(pageIndex)}
                        onPageChange={handleChangePage}
                        rowsPerPage={pageSize}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        disabled={disabledActionPagination}
                    />
                </div>

                <ModalRegisterMasterFollower
                    setOpenModalRegister={setOpenModalRegister}
                    handleClose={handleClose}
                    open={open}
                    setTypeRegister={setTypeRegister}
                />
                {typeRegister == 'FOLLOWER' && openModalRegister === true && <RegisterFollower
                    open={openModalRegister}
                    handleClose={handleCloseModalRegister}
                    title={''}
                />}


                {typeRegister == 'MASTER' && openModalRegister === true && <RegisterMaster
                    open={openModalRegister}
                    handleClose={handleCloseModalRegister}

                />}

                {openModalCopyMasterTrade === true && <CopyMasterTrade
                    open={openModalCopyMasterTrade}
                    handleClose={handleCloseModalCopyMasterTrade}
                    title={''}
                    data={{ dataMasterTradeId }}
                    triggerReload={triggerReload}
                />}

                {openModalAdvanceFilter === true && <ModalAdvanceFilter
                    open={openModalAdvanceFilter}
                    handleClose={handleCloseModalAdvanceFilter}
                    handleSave={handleSaveAdvanceFilter}
                    handleReset={handleResetAdvanceFilter}
                    handleChange={handChangeAdvProperty}
                    previewData={preViewPropertyFilter}
                />}
            </div>

            {
                openViewMaster === true && <div className={cx("detail-info-master")}>
                    <Stack>
                        <StyledTab tabs={TABS2}></StyledTab>
                    </Stack>
                </div>
            }
            {
                openModalStopCopy === true && <StopCopy
                    open={openModalStopCopy}
                    handleClose={handleCloseModalStopCopy}
                    title={''}
                    data={{ dataMasterTrade: openViewMaster ? dataMasterTradeView : dataMasterTradeId }}
                />
            }
        </>
    )
}